import { IconButton } from "@mui/material";
import { Menu } from "@mui/icons-material";
import React from "react";
export const MenuButton = (iconButtonProps) => (React.createElement(IconButton, { "aria-label": "Hauptmen\u00FC \u00F6ffnen", color: "secondary", size: "small", ...iconButtonProps },
    React.createElement(Menu, { fontSize: "small" })));
//# sourceMappingURL=menu-button.js.map